<div class="flex flex-col">
  <mat-label class="flex flex-row items-center gap-2" [ngClass]="labelClass">
    {{ label | translate }}
    <span *ngIf="required">*</span>
    <app-icon
      *ngIf="infoTooltip"
      class="cursor-pointer"
      [matTooltip]="infoTooltip | translate"
      iconName="info"
      size="sm"
      fill="#1f5792"
      matTooltipPosition="above"></app-icon>
  </mat-label>
  <mat-form-field color="warn" [ngClass]="{ 'mat-form-field-invalid': control?.invalid && control?.touched }">
    <input
      matInput
      [type]="type"
      [value]="value"
      [readonly]="isReadonly"
      [disabled]="isDisabled || control?.disabled"
      [placeholder]="placeholder | translate"
      [min]="type === 'number' ? minNumber : null"
      [max]="type === 'number' ? maxNumber : null"
      [attr.maxlength]="maxLength > 0 ? maxLength : null"
      [step]="type === 'number' ? 1 : null"
      (keypress)="onKeypress($event)"
      (input)="onInputChange($event)"
      (blur)="onTouched()" />

    <ng-container matSuffix>
      <ng-content select="[suffix]"></ng-content>
    </ng-container>
  </mat-form-field>
  <ng-container *ngIf="errorMessage; else flowValidationErrors">
    <mat-error [class]="errorMessageClass" *ngIf="control?.invalid && control?.touched">
      {{ errorMessage | translate }}
    </mat-error>
  </ng-container>
  <ng-template #flowValidationErrors>
    <mat-error flowValidationErrors *ngIf="control?.invalid && control?.touched"></mat-error>
  </ng-template>
</div>
